var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwhi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_62386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 23.9999C10.8185 23.9965 7.76821 22.7311 5.51851 20.4814C3.26882 18.2317 2.00344 15.1814 1.99999 11.9999C1.84699 3.04389 12.031 -2.98511 19.791 1.50889L21.344 2.37089L19.801 3.25089C13.101 6.93889 13.591 17.1209 20.601 20.1569L22.222 20.8879L20.755 21.8939C18.7684 23.2633 16.4129 23.9977 14 23.9999Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_62386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwhi);
export default __webpack_public_path__ + "static/media/OWHI.4ed9a22f1cfc6552ccb79a157b08d675.svg";
export { ForwardRef as ReactComponent };